import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem/SliderListItem';

const BackdropSlowZoomSpeedSlider = (props) => {
    const { speed, updateBackgroundSettings } = props;

    const onSpeedChange = useCallback((value) => {
        if (value === speed) return;
        updateBackgroundSettings({ slowZoom: { intensity: value } });
    }, [speed, updateBackgroundSettings]);

    return (
        <SliderListItem
            title='Speed'
            displayMultiplier={1}
            value={speed}
            min={1}
            max={100}
            step={1}
            onValueChange={onSpeedChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { slowZoom } = state.createPreview.present.videoSettings.background;
    return {
        speed: slowZoom?.intensity ?? 30
    };
};

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackdropSlowZoomSpeedSlider);
